
import session from '../api/session';
import { mapActions, mapGetters, mapState } from 'vuex';

export var cv_id = window.location.pathname.split('/')[2];

export var mixin_ajax = ({
    
    data: function() {
        return {
            api_url: '/api/' + cv_id + '/education/',
            modelObjects: [],
            // newModelObject() est toujours surdéfini dans le composant
            // qui appelle ce mixin
            newModelObject: function() {
                // Inutile de renseigner l'objet car il est surdéfini par les composants
                // qui appellent ce mixin.
                return { 
                }
            },
            isLoading: false,
            fullPage: false,
        }
    },
    computed: {
      ...mapState('loading', [
        'getLoadingAllState',
      ])

    },
    methods: {
        ...mapActions('loading', [
          'loadingAddElem',
        ]),


        getModelObjects: function() {
            this.isLoading = true;
            session.get(this.api_url)
                .then((response) => {
                    this.modelObjects = response.data;
                    this.isLoading = false;
                    this.loadingAddElem();
                    console.log('GET CALLED : ' + this.api_url);
                    console.log(response)
                })
                .catch((err) => {
                    this.isLoading = false;
                    this.loadingAddElem();
                    if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('======= getModelObjects error in response =======')
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('======= getModelObjects error in request =======')
                    console.log(err.request);
                    } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('======= getModelObjects error in else =======')
                    console.log('Err', err.message);
                    }
                })
        },

        addModelObject: function() {
            this.isLoading = true;
            console.log("Ajout d'une instance objectModel : ")
            console.log(this.newModelObject())
            var payload = this.newModelObject()
            // gestion de la protection csrf :
            // session.defaults.xsrfCookieName = 'csrftoken'
            // session.defaults.xsrfHeaderName = 'X-CSRFToken'
            session.post(this.api_url, payload)
                .then((response) => {
                    this.isLoading = false;
                    console.log(response)
                    console.log('Added : ' + response.data)
                    // insère dans la liste la nouvelle structure (avec l'id) obtenue par le server REST :
                    // ajout a la fin
                    this.modelObjects.splice(this.modelObjects.length, 0, response.data)
                    // ajout au début :
                    // this.modelObjects.unshift(response.data)
                    // inutile de rappeller la regénération de la liste :
                    // this.getModelObjects();
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.log(err.response);
                })
        },

        deleteModelObject: function(id, index) {
            console.log('Deleting --> ' + `${this.api_url}${id}/`)
            this.isLoading = true;
            // gestion de la protection csrf :
            // session.defaults.xsrfCookieName = 'csrftoken'
            // session.defaults.xsrfHeaderName = 'X-CSRFToken'
            session.delete(`${this.api_url}${id}/`)
                .then((response) => {
                    console.log(response)
                    console.log("DONE")
                    this.isLoading = false;
                    console.log(this.modelObjects)
                    this.modelObjects.splice(index, 1);
                    console.log(this.modelObjects)
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.log(err)
                    if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('======= deleteModelObject error in response =======')
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('======= deleteModelObject error in request =======')
                    console.log(err.request);
                    } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('======= deleteModelObject error in else! =======');
                    console.log('Err', err.message);
                    }
                })
        },

        updateModelObject: function(id, postedObject) {
            console.log('ERRORS : ' + this.$validator.errors.all())
            this.$validator.validateAll().then((result) => {
              if (result) {
                this.currentModelObject = postedObject
                console.log("Changement sur l'objet : " + this.currentModelObject.id);
                console.log(this.currentModelObject)
                // gestion de la protection csrf :
                // session.defaults.xsrfCookieName = 'csrftoken'
                // session.defaults.xsrfHeaderName = 'X-CSRFToken'
                var requested_url = `${this.api_url}${this.currentModelObject.id}/`
                console.log("url d'update : " + requested_url)
                session.put(`${this.api_url}${this.currentModelObject.id}/`, this.currentModelObject)
                    .then((response) => {
                        this.currentModelObject = response.data;
                          this.errmsg = '';
                    })
                    .catch((err) => {
                        if (err.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        console.log('======= updateModelObject error in response =======')
                        console.log(err.response.data);
                        console.log(err.response.status);
                        console.log(err.response.headers);
                        this.errmsg = err.response.data
                        console.log('ERRMSG : ' + Object.keys(this.errmsg))
                        } else if (err.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        console.log('======= updateModelObject error in request =======')
                        console.log(err.request);
                        } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('======= updateModelObject error in else =======')
                        console.log('Err', err.message);
                        }
                    })
              }
              else {
                console.log('Vee-Validate. Pas de soumission !!!')
              }
            })
          },
          updateModelObject2: function(id, postedObject) {
            this.isLoading = true;
            this.currentModelObject = postedObject
            console.log("Changement sur l'objet : " + this.currentModelObject.id);
            console.log(this.currentModelObject)
            // gestion de la protection csrf :
            // session.defaults.xsrfCookieName = 'csrftoken'
            // session.defaults.xsrfHeaderName = 'X-CSRFToken'
            session.put(`${this.api_url}${this.currentModelObject.id}/`, this.currentModelObject)
                .then((response) => {
                    this.isLoading = false;
                    this.currentModelObject = response.data;
                })
                .catch((err) => {
                    this.isLoading = false;
                    if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('======= updateModelObject error in response =======')
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('======= updateModelObject error in request =======')
                    console.log(err.request);
                    } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('======= updateModelObject error in else =======')
                    console.log('Err', err.message);
                    }
                })
        },
        
        
    },

    mounted: function() {
        console.log('---- Mounted called master ----> '+ this.api_url)
        this.getModelObjects();
    },
})
